/**
 * Card Section Component
 * 
 * Main section containing all three credit card options.
 */

import CreditCard from './CreditCard'
import { PLANS } from '../data/plans'
import '../styles/CardSection.css'

function CardSection() {
  return (
    <main className="main-content" role="main">
      <div className="container">
        <h2 className="section-title">Wählen Sie Ihren Plan</h2>
        
        <div className="cards-container">
          {PLANS.map((plan, index) => (
            <CreditCard 
              key={plan.id} 
              plan={plan} 
              index={index}
            />
          ))}
        </div>
      </div>
    </main>
  )
}

export default CardSection
